export default __webpack_public_path__ + "static/4168b16d-5024-46d0-922a-ae21966a2784-9308043db831bc578a919b7c39a63a68.woff2";